import { GET, POST, PUT, DELETE } from "./Fetch";

export const toLogin = async (payload) => {
  const res = await POST(`/login`, payload);
  return res;
};

export const toLogout = async (id) => {
  const res = await POST("/logout`", id);
  return res;
};

// USER

export const getUser = async (id) => {
  const res = await GET(`/users/${id}`);
  return res;
};

export const getUsers = async () => {
  const res = await GET(`/users/?page=1&order=desc&search=&limit=&orderby=id`);
  return res;
};

export const createUser = async (payload) => {
  const res = await POST(`/users`, payload);
  return res;
};

export const updateUser = async (id, payload) => {
  const res = await PUT(`/users/${id}`, payload);
  return res;
};

export const deleteUser = async (payload) => {
  const res = await DELETE(`/users/${payload}`);
  return res;
};

//emission type
export const getEmissionType = async () => {
  const res = await GET(`/emission/types`);
  return res;
};

//Scenario

export const getScenarios = async (payload) => {
  const res = await GET(
    `/scenarios?scenario_name=${
      payload ? payload?.name : ""
    }&activity_type_id=${payload ? payload?.activity : ""}`
  );
  return res;
};

export const createScenario = async (payload) => {
  const res = await POST(`/scenarios`, payload);
  return res;
};

export const updateScenario = async (id, payload) => {
  const res = await PUT(`/scenarios/${id}`, payload);
  return res;
};

export const deleteScenario = async (payload) => {
  const res = await DELETE(`/scenarios/?${payload}`);
  return res;
};

export const getScenarioStructure = async (payload) => {
  const res = await GET(
    `/scenarios/view/structure?file_name=${payload?.file}&sheet_name=${payload?.sheet}`
  );
  return res;
};

//activity
export const getActivity = async (payload) => {
  const res = await POST(`/activity`, payload);
  return res;
};

//emission

export const getEmission = async (payload) => {
  const res = await POST(`/emission`, payload);
  return res;
};
